import React from "react";

import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { X } from "lucide-react";

import { useCreateSentinel } from "../hooks";
import { SentinelForm } from "../components";

import { Header } from "../../../components/header";
import { parseSearchParams } from "../../../helpers/clean-object";

export const CreateSentinel: React.FC = () => {
  const [params] = useSearchParams();
  const { form, submit, loading } = useCreateSentinel({
    defaultValues: {
      ...parseSearchParams(params),
    },
    onCompleted: () => {
      toast.success("La sentinelle a été enregistré avec succès");
    },
  });

  return (
    <>
      <Header
        title="Sentinel"
        subtitle="Nouvelle Sentinelle"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/sentinels`,
            icon: <X />,
          },
        ]}
      />
      <div className="main-container">
        <SentinelForm
          loading={loading}
          submit={submit}
          form={form}
          disabledFields={Object.keys(parseSearchParams(params))}
        />
      </div>
    </>
  );
};
